module.exports = __webpack_public_path__ + "static/media/add-row.e1f484b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/add-row.svg
// module id = 1057
// module chunks = 3